import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Navbar from './components/Navbar'
import HomePage from './pages/HomePage';

function App() {

  return (
    <React.StrictMode>
      <BrowserRouter>

        <Navbar />

        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>

      </BrowserRouter>
    </React.StrictMode>
   
  );

}

export default App;